import React from 'react';

interface Props {
    taxDocument:any;
}

const TaxDocumentTotal = ({ taxDocument }: Props) => {
    return (
        <div className="sales-invoice-total">
            <div className="row justify-content-end">
                <div className="col-md-3">
                    <div className="form-group mb-2">
                        <label htmlFor="totalNet">Total Neto:</label>
                        <input
                            type="text"
                            id="totalNet"
                            className="form-control"
                            value={taxDocument?.total_neto || ''}
                            disabled
                        />
                    </div>

                    <div className="form-group mb-2">
                        <label htmlFor="totalTax">Total Impuestos:</label>
                        <input
                            type="text"
                            id="totalTax"
                            className="form-control"
                            value={taxDocument?.total_tax || ''}
                            disabled
                        />
                    </div>

                    <div className="form-group mb-2">
                        <label htmlFor="totalSale">Total:</label>
                        <input
                            type="text"
                            id="totalSale"
                            className="form-control"
                            value={taxDocument?.total_amount || ''}
                            disabled
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaxDocumentTotal;
